// Prompts the user with the browsers native 'Are you sure you want to leave'
// dialog. When navigating via javascript, always use `window.location.href`
// over `window.location` to prevent issues in Edge & IE.

function registerConfirmLeave() {
  if (process.env.NODE_ENV === 'development') {
    return null;
  }
  // Return true because most browsers do not allow a custom message
  window.onbeforeunload = function(e) {
    return true;
  };
}

function unregisterConfirmLeave() {
  window.onbeforeunload = null;
}

export { registerConfirmLeave, unregisterConfirmLeave };
